import { render, staticRenderFns } from "./StockTransferModal.vue?vue&type=template&id=04b552d8&scoped=true"
import script from "./StockTransferModal.vue?vue&type=script&lang=js"
export * from "./StockTransferModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b552d8",
  null
  
)

export default component.exports